import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import Scheduler, {SchedulerData, ViewTypes, DATE_FORMAT} from 'react-big-scheduler'
import 'react-big-scheduler/lib/css/style.css'
import moment from 'moment'

  class Calendar extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        calendar: []
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.RenderCalendar = () => {
        var events = this.state.calendar
        var events_to_map = events.sort(function (a, b) {
          return b.start - a.start;
        });

        var events_map = events_to_map.map((item, index) => {
          return <Row style={{marginRight: '0px', margin: '5px', textAlign: 'left', marginBottom: '15px', border: '1px solid silver', borderRadius: '20px'}}>
            <Col>
              <br/>
              {item.title}
              <br/><br/><br/>
            </Col>
            <Col style={{color: 'grey'}}>
              <br/>
              Start time: {item.start}
              <br/><br/>
              End time: {item.end}
              <br/><br/><br/>
            </Col>
          </Row>
        })

        return<div>
          {events_map}
        </div>
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'getSchedule', data)
      .then((res) => {
          let result = res.data
            this.setState({calendar: result})
            console.log(result)
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      return (
        <Row>
            <Helmet>
              <title>TRAINER CALENDAR - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Calendar
              </h4>
              <br/><br/>
              <Container>
                <this.RenderCalendar/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Calendar);